import { useForkBranchCommand } from "commands/definitions/branch/useForkCommand";
import { Dropdown, Stack, Text } from "prism-react";

const ContextItem: React.FC<{
  title: string;
  content?: string;
  onSelect?: (e: Event) => void;
}> = ({ title, content, onSelect }) => {
  return (
    <Dropdown.Item onSelect={onSelect}>
      <Stack css={{ width: 168 }} gap={1}>
        <Text>{title}</Text>
        {content && <Text color="neutral-fg-base">{content}</Text>}
      </Stack>
    </Dropdown.Item>
  );
};

/**
 * Contribution fork: it's used when an user doesn't have write
 * permission to the given repository, so they need to do a fork/contribution
 *
 * Contains the options:
 * - Regular fork (copy this repo on the their own github organization);
 * - Contribution fork: an internal abstraction to simplify the forking flow
 */
export const ForkContributionOptions: React.FC = () => {
  const contributeFork = useForkBranchCommand({
    target: "CONTRIBUTION_BRANCH",
  });
  const regularFork = useForkBranchCommand({
    target: "DEFAULT",
  });

  return (
    <>
      <ContextItem
        content={contributeFork.subtitle}
        onSelect={contributeFork.perform}
        title={contributeFork.name}
      />
      <ContextItem
        content="Create a duplication of this project in your team."
        onSelect={regularFork.perform}
        title="Fork project"
      />
    </>
  );
};

/**
 * Regular branching: it creates a new branch from a given
 * branch source (current or the source branch)
 */
export const ForkRegularOptions = () => {
  const defaultFork = useForkBranchCommand({
    target: "DEFAULT",
  });
  const currentFork = useForkBranchCommand({
    target: "CURRENT",
  });

  return (
    <>
      <Dropdown.Item onSelect={defaultFork.perform}>
        {defaultFork.name}
      </Dropdown.Item>
      <Dropdown.Item onSelect={currentFork.perform}>
        {currentFork.name}
      </Dropdown.Item>
    </>
  );
};
